<template>
  <div class="items-list-wrapper mt-6" v-if="visible">
    <transition-group class="items-list w-100" name="list-complete" tag="div">
      <div v-if="!links.length" class="mb-4" :key="-1">Нет доп. связей с блоками</div>
      <div v-else class="mb-4" :key="-3">Доп. блоки (вторичные связи вопроса):</div>
      <div class="row row-complete-item" v-for="link in links" :key="link.id">
        <div class="col-7">
          <v-select label="Блок" outlined dense hide-details :items="blockItemsFor(link)" item-text="title" item-value="id"
            v-model="link.block" @change="debouncedChanged(link)" />
        </div>
        <div class="col-3 pl-0">
          <v-text-field label="Вес" outlined dense v-model="link.weight" :error-messages="checkFloat(link.weight)" @input="debouncedChanged(link)" />
        </div>
        <div class="col-2 pl-0 text-right">
          <v-btn icon color="error" @click="removeLink(link)">
            <v-icon>mdi-delete-outline</v-icon>
          </v-btn>
        </div>
      </div>
      <div class="row row-complete-item" :key="-2">
        <v-btn class="add-button" fab dark small color="primary" @click="addLink" :disabled="!availableBlocksForNew.length">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </div>
    </transition-group>
  </div>
</template>

<script>
/* eslint-disable */
import { debounce } from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import { Q_TYPES } from '@/components/testEditor/QuestionTypes.js';
import { checkFloat, toFloat } from '@/common/util';

export default {
  props: {
    question: Object,
  },
  computed: {
    ...mapGetters({
      links: 'testEditor/extraBlockLinks',
      blocks: 'testEditor/blocks',
      errors: 'testEditor/errors',
    }),
    visible() {
      return this.question.type === Q_TYPES.QUESTON_RADIO && !!this.question.block;
    },
    otherBlocks() {
      return this.blocks.filter(b => b.id !== this.question.block);
    },
    // блоки, уже занятые какой-либо из текущих связей (бэк не разрешает дубль question+block)
    usedBlockIds() {
      return this.links.map(l => l.block);
    },
    availableBlocksForNew() {
      return this.otherBlocks.filter(b => !this.usedBlockIds.includes(b.id));
    },
  },
  watch: {
    'question.id': {
      immediate: true,
      handler() {
        if (this.visible)
          this.loadExtraBlockLinks(this.question);
      },
    },
  },
  methods: {
    ...mapActions({
      loadExtraBlockLinks: 'testEditor/loadExtraBlockLinks',
      addExtraBlockLinkAction: 'testEditor/addExtraBlockLink',
      saveExtraBlockLink: 'testEditor/saveExtraBlockLink',
      delExtraBlockLink: 'testEditor/delExtraBlockLink',
    }),
    async addLink() {
      const block = this.availableBlocksForNew[0];
      if (!block) return;
      const response = await this.addExtraBlockLinkAction({ question: this.question, block, weight: 1 });
      if (!response) this.showSaveError('add');
    },
    // список для конкретной строки: доступные блоки + тот, что выбран в этой строке сейчас
    // (иначе он пропадёт из v-select, т.к. уже "занят" сам собой)
    blockItemsFor(link) {
      return this.otherBlocks.filter(b => b.id === link.block || !this.usedBlockIds.includes(b.id));
    },
    async saveLink(link) {
      // не шлём на бэк заведомо невалидный вес - ошибка уже видна под полем через checkFloat
      if (typeof checkFloat(link.weight) === 'string') return;
      link.weight = toFloat(link.weight);
      const response = await this.saveExtraBlockLink(link);
      if (!response) this.showSaveError('save');
    },
    debouncedChanged: debounce(function (link) {
      this.saveLink(link);
    }, 500),
    async removeLink(link) {
      const response = await this.delExtraBlockLink(link);
      if (!response) this.showSaveError('del');
    },
    // показываем пользователю причину ошибки сохранения/создания связи (например, дубль блока)
    showSaveError(type) {
      const err = this.errors[type];
      const message = err && typeof err === 'object'
        ? Object.values(err).flat().join(' ')
        : 'Не удалось сохранить связь с блоком';
      this.$toast.error(message || 'Не удалось сохранить связь с блоком', '', { position: 'topRight' });
    },
    checkFloat,
  },
}
</script>
